module.exports = __webpack_public_path__ + "img/star.8dface4c.svg";